// crashlytics.tsx
import Bugsnag from "@bugsnag/react-native"
import { crashlytics, logger } from "capsule"
import _ from "lodash"
import { Platform } from "react-native"

let isStarted = false

function ensureBugsnagStarted() {
  if (isStarted || Platform.OS === "web") {
    return
  }
  // La configuration Bugsnag est entièrement gérée côté natif
  Bugsnag.start()
  isStarted = true
}

const bugsnag = {
  leaveBreadcrumb: (name: string, meta?: Record<string, any>, type?: any) => {
    ensureBugsnagStarted()
    if (Platform.OS !== "web") {
      Bugsnag.leaveBreadcrumb(name, meta, type)
    }
  },
  notify: (err: Error) => {
    ensureBugsnagStarted()
    if (Platform.OS !== "web") {
      Bugsnag.notify(err)
    }
  },
}

const reportError = (errorCode: number, errorMessage: string, err?: Error): void => {
  const message = !_.isString(errorMessage) ? JSON.stringify(errorMessage) : errorMessage
  const error = err ?? new Error(`${errorCode} - ${message}`)

  bugsnag.leaveBreadcrumb("reportError", { errorCode, errorMessage }, "error")
  crashlytics().recordError(error)
  bugsnag.notify(error)
  logger("reportError", errorCode, errorMessage)
}

export const errorCodes = { smsLogin: 20, archive: 21, notifee: 22, phase: 23 }

export default { reportError, errorCodes, bugsnag, ensureBugsnagStarted }
